import { Box, SxProps } from '@mui/material';
// config
import { DEFAULT_HEADER_HEIGHT } from './config';

const HEADER_COLOR = 'rgba(33,43,54,255)';

interface CaptureHeaderWrapperProps {
  children: React.ReactNode;
  sx?: SxProps;
}

export const CaptureHeaderWrapper = ({ children, sx }: CaptureHeaderWrapperProps) => {
  return (
    <Box
      sx={{
        position: 'relative',
        zIndex: 10000,
        display: 'flex',
        minHeight: DEFAULT_HEADER_HEIGHT,
        width: '100%',
        backgroundColor: HEADER_COLOR,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
